<template>
  <div class="clientOnboarding row">
    <coaching-pitch />
    <div class="col info-col" >
      <span class="row current">
        <!-- <current number="6" :total="total" step="Payment" v-if="state=='payment'"/> -->
      </span>
      <div class="card card--white small-top">
        <div class="card card--container">
      <form @submit.prevent="next" class="form full-sm" v-if="state=='user'">
        <current number="1" :total="total" step="User Information" v-if="state=='user'"/>
        <div>
          <h-input label="First Name" required v-model="first_name"/>
          <h-input label="Last Name" required v-model="last_name"/>
        </div>
        <div >
          <h-input label="Email" required outline v-model="email"/>
          <h-input label="Confirm Email" required outline v-model="emailConfirmation"/>
        </div>
        <div >
          <h-input label="Password" required outline v-model="password" type="password" />
          <h-input label="Confirm Password" required outline type="password" v-model="passwordConfirmation"/>
        </div>
        <div class="small-top">
          <div>
            Not all browsers or mobile devices support push notifications (primarily iPhones).
            If you feel this is an issue or would prefer, we can send your reminders as text notifications instead of email or app notifications.
          </div>
           <div><i>*You can always change this in settings</i></div>
          <v-checkbox label="I would like to receive text reminders" v-model="allow_notice_sms"/>
          <h-input label="Phone number" outline v-model="phone_number" mask="phone" v-if="allow_notice_sms"/>
        </div>
        <v-checkbox v-model="tos">
          <span slot="label">I agree to <a href="/terms-of-service" target="_blank">Terms of Service</a></span>
        </v-checkbox>
        <v-alert :value="error" type="error">{{error}}</v-alert>
        <h-btn class="full-width" color="primary" :disabled="!tos" type="submit">Continue</h-btn>
      </form>
      <form class="form full-sm" @submit.prevent="next" v-if="state=='workWeek'">
        <current number="2" :total="total" step="Work Week" v-if="state=='workWeek'"/>
        <h4>What time of the day would you like to receive coach created exercises?</h4>
        <timepicker v-model="userTimeInfo.generate_exercises_at"/>
        <h4>What time of the day would you like to receive reflection reminders?</h4>
        <timepicker v-model="userTimeInfo.generate_pulse_at"/>
        <h4>What days of the week would you like to receive new exercises?</h4>
        <week-btns class="small-top" :week="workWeek" color="black" />
        <h4>What days of the week would you like to receive reflection reminders?</h4>
        <week-btns class="small-top" :week="generatePulseOn" color="black" />
        <v-alert :value="error" type="error">{{error}}</v-alert>
        <h-btn @click="back" v-if="error">Back</h-btn>
        <h-btn type="submit" class="small-top full-width" v-else>Continue</h-btn>
      </form>
      <form class="form full-sm explanation" @submit.prevent="next" v-if="state=='rewards'">
            <current number="3" :total="total" step="Rewards" v-if="state=='rewards'" />
          <div>
            Change is hard. Really hard. We want to reward you for your hard work. And we have a few ways to do it.
          </div>
          <div class="small-top">
            Our favorite way is the <a href="/create-the-change/1/send-a-girl-to-school" target="_blank">Create the Change Campaign</a>.
            Every time you complete an exercise, lesson, or daily reflection you'll be given the chance to spin the Change Wheel
            to earn points towards the campaign.
          </div>
          <div class="small-top">
            The Change points are used to donate to a charity. Our current charity works with impoverished
            families helping them to send their girls to school.
          </div>
          <div class="small-top">
          You can find more about how the <a href="/create-the-change/1/send-a-girl-to-school" target="_blank">Create the Change Campaign</a> works <a href="/create-the-change/1/send-a-girl-to-school" target="_blank">here</a>.
          </div>
          <div class="small-top">
            <b>We create the change we want to see--inside and outside.</b>
          </div>
          <div>
            <v-checkbox v-model="raffle_opt_in"><span slot="label">I want to participate in the Create the Change Campaign</span></v-checkbox>
          </div>
        <div>
          You'll also be rewarded when completing exercises or reflections by funny memes or inspiring quotes.
        </div>
        <div class="small-top">
          <h-select :items="rewards" :no-none='true' item-value="value" item-text="display" label="What kind of reward would you like?" v-model="reward"></h-select>
        </div>
        <v-alert :value="error" type="error">{{error}}</v-alert>
        <h-btn @click="back" v-if="error">Back</h-btn>
        <h-btn class="small-top full-width" type="submit" v-else>Continue</h-btn>
      </form>
      <form class="form full-sm" v-if="state=='selectAoF'" @submit.prevent="next">
        <current number="4" :total="total" step="Select Areas Of Focus" v-if="state=='selectAoF'"/>
        <select-aof :data="pickedAOF" :program="program" :areas="areas">
          <div class="section-headers">Select your areas of focus.</div>
        </select-aof>
        <v-alert :value="error" type="error">{{error}}</v-alert>
        <h-btn class="small-top" @click="back" v-if="error">Back</h-btn>
        <h-btn type="submit" class="small-top full-width" :disabled="loading" v-if="offering.price">Continue</h-btn>
        <h-btn type="submit" class="small-top full-width" :disabled="loading" v-else>Sign Up</h-btn>
      </form>
      <div class="flex-center">
        <div>Already a member? <router-link to='/sign-in'>Sign in</router-link></div>
      </div>
      <payment :serverError="error" :disabled="loading" style="width: 100%" class="form" :offering="offering" v-if="state=='payment'" @token="finish"/>
        </div>

      </div>
    </div>
    <modal v-if="badUrl" :btn="'Close'" :title="'Error'" @close="$router.push('/login')" @submit="$router.push('/login')">
      <div v-if="badUrl == 'token'">
        This invitation is no longer active. 
      </div>
      <div v-else>
        This subscription plan is no longer active.
      </div>
    </modal>
  </div>
</template>

<script>
import selectAof from "@/pages/account/components/selectAoF";
import coachingPitch from "@/components/coachingPitch";
import payment from "./payment";
import axios from "axios";
import AuthUser from "@/services/api/authUser";
import current from "./current";
import weekBtns from "@/components/weekBtns";
import timepicker from "@/components/timepicker";
import moment from "moment-timezone";
import modal from "@/components/modal/default";
import HOME_MAP from "@/services/homeMap";

export default {
  data() {
    return {
      badUrl: "",
      state: "user",
      first_name: "",
      last_name: "",
      email: "",
      emailConfirmation: "",
      password: "",
      passwordConfirmation: "",
      workWeek: [],
      start_at: "",
      end_at: "",
      payment: {},
      pickedAOF: {areas_of_focus: []},
      areas: [],
      program: {},
      raffle_opt_in: true,
      allow_notice_sms: false,
      phone_number: "",
      generatePulseOn: [],
      userTimeInfo: {
        generate_pulse_at: "20:00",
        generate_exercises_at: "06:00"
      },
      reward: "any",
      offering: {},
      error: "",
      loading: false,
      tos: false,
      states: [],
      rewards: [
        { value: 'img', display: "Funny images and gifs", },
        { value: 'quote', display: "Inspiring quotes"},
        { value: 'any', display: "Funny images and inspiring quotes"},
        { value: 'none', display: "None" }
      ]
    };
  },
  created() {
    let full = window.location.hostname;
    let sub = full.split(".")[0];
    this.states = ["user", "workWeek"];
    this.states = [
      { name: "user", validate: () => this.validateUser() },
      { name: "workWeek", validate: () => this.validateWorkWeek() } ,
      { name: "rewards", validate: () => true },
    ];
    sub = sub.toLowerCase();
    axios.get(`${process.env.VUE_APP_API_URL}client/offering/`, {params: {sub_domain: sub, invitation: this.$route.params.token, id: this.$route.params.id}})
      .then(({data}) => {
        this.program = data.program;
        this.areas = data.areas;
        this.offering = data;
        if (this.offering.program && !this.offering.program.assign_all) {
          this.states = [...this.states, { name: 'selectAoF', validate: () => this.validateAoF() }];
        }
        if (this.offering.price) {
          this.states = [...this.states, {name: 'payment', validate: () => this.paymentValidation() }]
        }
        if (this.$route.params.token) {
          this.first_name = data.first_name;
          this.last_name = data.last_name;
          this.email = data.email;
          this.emailConfirmation = data.email;
        }
      })
      .catch(() => {
        if (this.$route.params.token) {
          this.badUrl = 'token'
        } else {
          this.badUrl = 'subscription'
        }
      })
  },
  components: { selectAof, payment, current, coachingPitch, weekBtns, timepicker, modal },
  methods: {
    paymentValidation() {
      return true;
    },
    validateUser() {
      if (this.email != this.emailConfirmation) {
        this.error = "Email and email confirmation does not match";
        return false;
      }

      if (this.password != this.passwordConfirmation) {
        this.error = "Password confirmation does not match";
        return false;
      }
      return true;
    },
    validateWorkWeek() {
      if (!this.workWeek.length) {
        this.error = "Please select days of the week";
        return false;
      }
      return true;
    },
    validateHabits() {
      return true;
    },
    validateAoF() {
      if (this.pickedAOF.areas_of_focus.length !== this.program.max_number_of_allowed_groups) {
        this.error = "Make sure you've picked all your areas of focus";
        return false;
      }
      return true;
    },
    next() {
      this.error = "";
      let currentStateIndex = this.states.findIndex(state => state.name == this.state);
      let state = this.states[currentStateIndex];
      if (!state.validate()) {
        return;
      }
      if (currentStateIndex == this.states.length - 1) {
        this.finish();
      } else {
        this.state = this.states[currentStateIndex + 1].name;
      }
    },
    back() {
      let currentStateIndex = this.states.findIndex(state => state.name == this.state);
      this.state = this.states[currentStateIndex - 1].name;
    },
    checkTime() {
      this.state = "selectAoF";
    },
    removeWeekDay(day) {
      this.workWeek = this.workWeek.filter(d => d !== day);
    },
    finish(token) {
      this.error = "";
      if (this.loading) {
        return;
      }
      const user = {
        first_name: this.first_name,
        last_name: this.last_name,
        email: this.email,
        email_confirmation: this.emailConfirmation,
        password: this.password,
        password_confirmation: this.passwordConfirmation,
        generate_pulse_on: this.generatePulseOn,
        offering: this.offering.id,
        areas: this.pickedAOF.areas_of_focus,
        generate_exercises_at: this.userTimeInfo.generate_exercises_at,
        generate_pulse_at: this.userTimeInfo.generate_pulse_at,
        timezone: moment.tz.guess(),
        work_week: this.workWeek,
        habit: this.habit,
        raffle_opt_in: this.raffle_opt_in,
        reward: this.reward,
        allow_notice_sms: this.allow_notice_sms,
        phone_number: "1" + this.phone_number,
        invitation: this.$route.params.token,
        stripe_token: token ? token.token : undefined
      };
      this.loading = true;
      axios
        .post(`${process.env.VUE_APP_API_URL}client/offering/`, user)
        .then(() => {
          return AuthUser.login({
            email: this.email,
            password: this.password
          }).then(() => {
            this.$router.go(HOME_MAP[this.offering.home]);
          });
        })
        .catch(({response}) => {
          if (response.status >= 500) {
            this.error = "There was a server error. Our staff has been notified. Please try again later";
          } else {
            this.error = Object.keys(response.data).map(key => response.data[key][0]).join("\n");
          }
        })
        .finally(() => (this.loading = false));
    }
  },
  computed: {
    reqAof() {
      return !this.program.assign_all;
    },
    reqPayment() {
      return this.offering.price !== 0;
    },
    total() {
      return this.states.length;
    }
  }
};
</script>

<style lang="less" scoped>
@sm: 640px;

.clientOnboarding {
  max-width: 800px;
  margin: 50px auto;
  // padding: 20px;
  h1 {
    font-size: 34px;
    letter-spacing: 1px;
  }
  li, h2, h3, h4 {
    padding-top: 12px;
    color: black;
  }
  h2,h3,h4 {
    color: black;
    letter-spacing: 1px;
  }
  li {
    font-size: 16px;
    font-weight: 500;
  }
  .hide-sm {
    display: none;
  }

  .current {
    span {
      margin-left: 12px;
    }
  }

  .row {
    flex-direction: row;
    width: 100%;
  }
  .form {
    width: 100%;
  }

  .no-top {
    margin-top: 0px !important;
  }
  .col {
    width: 100%;
  }
  .info-col {
    max-width: 400px;
  }
  .explanation {
    .small-top {
      margin-top: 15px;
    }
  }

  @media (min-width: 480px) {
    .landing-description {
      display: flex !important;
      flex-direction: column;
      justify-content: center;
      margin-right: 40px;
      height: 80vh;
      flex: 3;
    }
    .hide-sm {
      display: inline;
    }


    .col {
      display: flex;
      flex-direction: column;
      width: 100%;
    }

    .row {
      display: flex;
      flex-direction: row;
      .v-input {
        padding-left: 8px;
      }
    }

    .form {
      flex: 1;
      padding: 10px;
      flex-direction: column;
    }

    .user-info {
      display: flex;
      .row;
    }

    img {
      flex: 2;
      width: 70%;
      max-height: 80vh;
    }
  }
}
</style>
